import { useState } from 'react';
import { Grid, InputLabel, Typography, useMediaQuery } from '@mui/material';
import { FormInput } from 'gf-ui-components-mui-lib';
import { IoEye, IoEyeOff } from "react-icons/io5";
import { useField } from 'formik';

interface IInputWrapper {
  htmlFor?: string;
  label?: string;
  placeholder?: string;
  name: string;
  type?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  styles?: any;
  disabled?: boolean;
  handleBlur?: any;
  handleFocus?: any;
  leftPanel?: any;
  setIsFocusFields?: any;
  isFocusedFields?: any;
  value?: any;
  popupCountryName?: string;
  popupPhoneNumberName?: string;
  endIcon?: any;
  startIcon?: any;
  dots?: any;
  popupCountryWidth?: string;
  popupPhoneWidth?: string;
  show?: boolean;
  endIconClick?: any;
  errorStyles?: any;
  isLabelButton?: boolean;
  labelButton?: any;
  errors?: boolean;
  manual?: boolean;
}

const InputWrapper = (props: IInputWrapper) => {
  const [field, meta] = useField(props);
  const [show, setShow] = useState(false);
  
  const formInputStyles = {
    input: {
      '&::placeholder': {
        textOverflow: 'ellipsis !important',
        color: 'var(--gray-500, #667085)',
        fontFamily: 'Poppins',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
        opacity: 1
      }
    },
    '& .MuiOutlinedInput-root': {
      padding: '0px 14px !important',
      // gap: '8px',
      height: '48px !important',
      borderRadius: '8px',
      backgroundColor: props.disabled ? 'var(--gray-050, #FAFAFA)' : 'var(--gray-white, #FFF)'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (meta.error || props.errors) || props.manual ? '1px solid #F27A7A' : '1px solid #d5d4dc'
    },
    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      border: (meta.error || props.errors) || props.manual ? '1px solid #F27A7A' : '1px solid #d5d4dc',
      boxShadow: 'none',
      padding: 0,
      paddingBottom: props.dots && !props.show ? '5px' : '1.5px'
    },
    '& .MuiOutlinedInput-root:hover fieldset': {
      border: (meta.error || props.errors) || props.manual ? '1px solid #F27A7A' : '1px solid #d5d4dc'
    },
    '& .MuiInputBase-input': {
      height: '22px',
      backgroundColor: 'inherit',
      color:
        props.dots && props.type === 'password' ? '#333' : props.disabled ? 'var(--gray-500, #667085) !important' : 'var(--gray-black, #000)',
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: props.dots && !props.show ? '35px' : '16px',
      // lineHeight: '22px',
      padding: 0,
      marginLeft: '10px',
      // paddingBottom: props.dots && !props.show ? '5.3px' : '1.5px'
    },
    '& .MuiInputAdornment-root': { paddingLeft: '0px', margin: '0px' }
  };
  const inputLabelStyles = {
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'var(--gray-700, #344054)'
  };

  return (
    <Grid item container sx={{ pointerEvents: props.disabled ? 'none' : 'all', gap: '8px' }}>
      {props.label && (
        <Grid
          item
          container
          sx={{
            justifyContent: 'space-between'
          }}
        >
          <InputLabel sx={inputLabelStyles} htmlFor={props.name}>
            {props.label}
          </InputLabel>
          {props.isLabelButton && props.labelButton}
        </Grid>
      )}
      <Grid item xs={12}>
        <FormInput
          sx={{ ...formInputStyles }}
          {...{
            ...field,
            placeholder: props?.placeholder,
            // disabled: props.disabled,
            id: props.name,
            ...(props.value && { value: props.value }),
            name: props.name,
            type: show || props.type !== 'password' ? 'text' : 'password',
            startIcon: props.startIcon ? (
              props.startIcon
            ) : null,
            endIcon: props.endIcon ? (
              props.endIcon
            ) : props.type === 'password' ? (
              !show && !props.show ? (
                <IoEye
                  cursor={'pointer'}
                  size={18}
                  onClick={() => {
                    setShow(!show);
                  }}
                />
              ) : (
                <IoEyeOff size={18} cursor={'pointer'} onClick={() => setShow(!show)} />
              )
            ) : null
          }}
        />
        {meta.error || props?.errors ? (
          <Typography data-testid={`${props.name}-error-message`} sx={{ fontSize: '10px', color: '#F27A7A', fontFamily: 'Poppins', lineHeight: '16px' }}>
            {meta.error}
          </Typography>
        ) : (
          <Typography
            sx={{ fontSize: '10px', color: 'transparent', fontFamily: 'Poppins', lineHeight: '16px', ...props.errorStyles }}
          >
            &nbsp;&nbsp;
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
export default InputWrapper;
